module.exports = __webpack_public_path__ + "static/media/LiveChat.3bdd9471.svg";